module.exports = __webpack_public_path__ + "static/media/icon_businessOk.b8b7db74.svg";